import React, { useRef } from 'react';
import '../styles/ToggleSwitch.css';

const ToggleSwitch = ({ isOn, onToggle, disabled = false, switchId }) => {
  // If no switchId is provided, generate a simple one (not guaranteed unique for multiple instances without labels)
  // For robust accessibility, a unique switchId should always be provided when used with an external label.
  const id = switchId || `toggle-switch-${Math.random().toString(36).substr(2, 9)}`;
  const inputRef = useRef(null);

  const handleDisplayClick = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        id={id}
        type="checkbox"
        className="Toggle__input"
        checked={isOn}
        onChange={e => onToggle(e.target.checked)}
        disabled={disabled}
      />
      <span 
        className="Toggle__display" 
        onClick={handleDisplayClick} 
        aria-hidden="true"
      >
        {/* SVGs for on/off states could go here if desired, as per Giraudel's full example */}
      </span>
    </>
  );
};

export default ToggleSwitch;
